import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn } from '@angular/router';
import { map } from 'rxjs';
import { RouteHandlerService } from '../services/route-handler.service';

export const customDomainEventSlugMatchGuard: CanMatchFn = (_route, segments) => {
    const routeHandler = inject(RouteHandlerService);
    return routeHandler.isExternalCustomDomain() && routeHandler.hasEventSlugInPath(segments);
};

export const verifyEventSlugGuard: CanActivateFn = (_route, state) => {
    const routeHandler = inject(RouteHandlerService);
    const slug = routeHandler.getEventSlugFromUrl(state.url);
    if (!slug) {
        return false;
    }
    return routeHandler.verifyEventSlugExists(slug).pipe(map((exists) => exists));
};
